import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { translate } from "../../../infrastructure/translate/localization";

export default function SuccessfulPaymentPage() {
  return (
    <main className="section">
      <div className="card">
        <div className="card-body">
          <div className="card-title">
            {translate("subsidy-section.allowance-delivery-success")}
          </div>
          <div className="text-center mt-3">
            <FontAwesomeIcon
              icon="check-circle"
              style={{ fontSize: "8rem", color: "limegreen" }}
            />
          </div>
        </div>
      </div>
    </main>
  );
}
